import type { StorageAdapter } from './types';
import { consumeAsyncValue } from './async-value';

export interface IdentityState {
  uuid: string;
  isNewVisit: number; // 1: 新访客, 0: 老访客
}

const UUID_STORAGE_KEY = '_hss_track_uuid_';

/**
 * 生成 32 位无横线随机 UUID 字符串
 */
export function generate32BitUuid(): string {
  try {
    if (typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function') {
      return crypto.randomUUID().replace(/-/g, '');
    }
  } catch {
    // 宿主 crypto 不可用时使用既有随机数降级策略。
  }
  let result = '';
  const chars = 'abcdef0123456789';
  for (let i = 0; i < 32; i++) {
    result += chars.charAt(Math.floor(Math.random() * chars.length));
  }
  return result;
}

/**
 * 访客设备唯一标识管理器
 */
export class IdentityManager {
  private currentIdentity: IdentityState | null = null;

  constructor(private storage: StorageAdapter) {}

  /**
   * 获取当前访客标识与新访客状态
   */
  public getIdentity(): IdentityState {
    if (this.currentIdentity) {
      return this.currentIdentity;
    }

    try {
      const storedUuid = this.storage.getItem(UUID_STORAGE_KEY);
      consumeAsyncValue(storedUuid);
      if (typeof storedUuid === 'string' && storedUuid.length === 32) {
        this.currentIdentity = { uuid: storedUuid, isNewVisit: 0 };
        return this.currentIdentity;
      }
    } catch {
      // 存储异常降级处理
    }

    // 新增访客
    const newUuid = generate32BitUuid();
    try {
      consumeAsyncValue(this.storage.setItem(UUID_STORAGE_KEY, newUuid));
    } catch {
      // 存储写入失败降级
    }

    this.currentIdentity = { uuid: newUuid, isNewVisit: 1 };
    return this.currentIdentity;
  }
}
